import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";
import { useStudent } from "../../contexts/auth/StudentContext";

export function CheckoutSesssion() {

    const { stripePromise, checkoutSession } = useStudent();

    return (
        <div id="checkout">
        <EmbeddedCheckoutProvider
            stripe={stripePromise}
            options={{ clientSecret: checkoutSession?.client_secret }}
        >
            <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
        </div>
    )
}